import React, { createContext, useCallback, useContext, useState } from "react";

export const SlotListContext = createContext({});

export const SlotListProvider = ({ children }) => {
  const [listOptions, setListOptions] = useState({
    filterParams: {
      status: [],
      responsible: undefined,
      requester: undefined,
      directory: undefined,
      kind: undefined,
      budgeted: undefined,
      modalityId: undefined,
      committees: [],
      companies: [],
      presenters: [],
      startDate: null,
      endDate: null,
      statusMaterial: undefined,
      keyWord: undefined,
    },
    pagination: {
      page: 0,
      size: 5,
    },
  });

  const updateFilterParams = useCallback((params) => {
    setListOptions((oldValue) => ({
      ...oldValue,
      filterParams: params,
    }));
  }, []);

  const updatePagination = useCallback((paginationOption) => {
    setListOptions((oldValue) => ({
      ...oldValue,
      pagination: paginationOption,
    }));
  }, []);

  return (
    <SlotListContext.Provider
      value={{ listOptions, updateFilterParams, updatePagination }}
    >
      {children}
    </SlotListContext.Provider>
  );
};

export function useSlotList() {
  const context = useContext(SlotListContext);

  if (!context) {
    throw new Error("useSlotList must be used within an SlotListProvider.");
  }

  return context;
}
